import { servicesURL } from '.';
import { getAccessToken, onUnauthorized } from './auth';
import axios, { AxiosInstance } from 'axios';

export type Service = {
  id: string;
  name: string;
  durationInMinutes: number;
};

export type ServiceWriteModel = Omit<Service, 'id'>;

function getServiceApi(): AxiosInstance {
  const accessToken = getAccessToken();
  if (!accessToken) {
    onUnauthorized();
    throw new Error('Sessão expirada');
  }

  return axios.create({
    baseURL: servicesURL,
    headers: { Authorization: `Bearer ${accessToken}` },
  });
}

export async function createService(
  service: ServiceWriteModel,
): Promise<Service> {
  const api = getServiceApi();

  const res = await api.post('', service);

  return res.data as Service;
}
export async function updateService(
  id: string,
  service: ServiceWriteModel,
): Promise<Service> {
  const api = getServiceApi();

  const res = await api.put(`/${id}`, service);

  return res.data as Service;
}
export async function getAllServices(): Promise<Service[]> {
  const api = getServiceApi();

  const res = await api.get('');

  return res.data as Service[];
}

export async function getServiceByID(id: string): Promise<Service> {
  const api = getServiceApi();

  const res = await api.get(`/${id}`);

  return res.data as Service;
}

export async function deleteService(id: string): Promise<void> {
  const api = getServiceApi();

  await api.delete(`/${id}`);
}
